import { Box, Button, Skeleton } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';

const ReportBreadcrumbs = () => {
  const { breadcrumbs } = useProgressBar();

  if (!breadcrumbs?.startOperatingYear) {
    return (
      <Box role="presentation" pt={4} px={2}>
        <Breadcrumbs aria-label="breadcrumb">
          <Skeleton animation="wave" variant="text" width={350} />
        </Breadcrumbs>
      </Box>
    );
  }

  const isSubtitleExist = !!breadcrumbs.subtitle;

  const breadcrumbsYear = `${
    breadcrumbs.endOperatingYear
      ? `${breadcrumbs.startOperatingYear} - ${breadcrumbs.endOperatingYear}`
      : breadcrumbs.startOperatingYear
  }`;

  return (
    <Box role="presentation" pt={4} px={2}>
      <Breadcrumbs aria-label="breadcrumb">
        <Button
          variant="text"
          color="info"
          href="/"
          sx={{ paddingX: 0, minWidth: 'auto' }}
        >
          หน้าหลัก
        </Button>
        <Button
          variant="text"
          color="info"
          href={`/?startOperatingYear=${breadcrumbs.startOperatingYear}&report=${breadcrumbs.reportId}`}
          sx={{ paddingX: 0, minWidth: 'auto' }}
        >
          {breadcrumbsYear}
        </Button>
        <Typography
          fontWeight={isSubtitleExist ? 400 : 800}
          color="text.primary"
        >
          {breadcrumbs.title}
        </Typography>
        {isSubtitleExist && (
          <Typography fontWeight={800} color="text.primary">
            {breadcrumbs.subtitle}
          </Typography>
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default ReportBreadcrumbs;
